import { baseUrl } from "@/app.config.js";

export default function UploadFile(tempFilePath, taskFn){
  return new Promise((resolve, reject) => {
    // 创建上传任务
    const uploadTask = uni.uploadFile({
      url: baseUrl + '/user/base/uploadFile',
      filePath: tempFilePath,
      name: 'file',
      success: (uploadFileRes) => {
        console.log('上传文件成功:', JSON.parse(uploadFileRes.data).data)
        resolve(JSON.parse(uploadFileRes.data).data)
      },
      fail: reject
    })

    if(taskFn){
      taskFn(uploadTask)
    }
  })
}